import { useForgotPassword } from '../hooks/use-forgot-password';
import { ForgotPasswordForm } from '@/components/organisms/forms/forgot-password-form';
import type { ForgotPasswordFormData } from '@/lib/validations';

export function ForgotPasswordContainer() {
  const { sendResetEmail, isLoading, error, success, clearError, reset } = useForgotPassword();

  const handleSubmit = async (data: ForgotPasswordFormData) => {
    await sendResetEmail({ email: data.email });
  };

  return (
    <ForgotPasswordForm
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      success={success}
      onErrorClear={clearError}
      onReset={reset}
    />
  );
}
